import { render } from "./index.vue?vue&type=template&id=f972ec5c&ts=true"
import script from "./player-icons.ts?vue&type=script&lang=ts"
export * from "./player-icons.ts?vue&type=script&lang=ts"

import "./player-icons.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "C:\\Users\\Devin\\Desktop\\drawing app\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__